<template>
    <div>
        <link-expenses v-model="expenseLinkSidebar" :transaction="transaction" :account="accountData" @submit="submit"/>
        <base-loading :visible="isLoading" />
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-4 md:col-span-4 md:col-start-1  xs:col-start-1">
               <vs-input :value="accountData.ClientName" disabled class="w-full"/>
            </div>
             <div class="col-span-4 md:col-span-2 md:col-start-5  xs:col-start-1">
               <vs-input :value="'*********' + accountData.account_suffix" disabled class="w-full" />
            </div>
            <div class="col-span-4 md:col-span-2 md:col-start-7  xs:col-start-1">
               <vs-input :value="reportData.transaction_reference" disabled class="w-full" />
            </div>
            <div class="col-span-12 md:col-span-2 md:col-start-11  xs:col-start-1">
                <search-input v-model="search" @search="onSearch" @clear="onSearch" />
            </div>
            <div class="col-span-full col-start-1">
                <report-transactions-table
                    :items="items" 
                    @loadMore="loadMore" 
                    @linkExpenses="onlinkExpenses"
                    @sortChanged="onSortChanged" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useNotifier } from '@/composables/useNotifier';
import { useReportTransactions } from '../../composables/useReportTransactions';
import { useNavigator } from '@/composables/useNavigator';
import BaseLoading from '@/views/app/components/BaseLoading';
import SearchInput from '@/views/app/components/SearchInput';
import ReportTransactionsTable from './components/ReportTransactionsTable';
import LinkExpenses from './components/LinkExpenses';
const { getParam } = useNavigator();
const { notify } = useNotifier();
const reportTransactions = useReportTransactions();
const accountData = computed(() => reportTransactions.state.account);
const reportData = computed(() => reportTransactions.state.report);
const items = computed(() => reportTransactions.state.items);
const currentPage = computed(() => reportTransactions.state.currentPage);
const lastPage = computed(() => reportTransactions.state.lastPage);
const isLoading = computed(() => reportTransactions.state.loading);

const search = ref('');
const sort = ref({});
const report = getParam('report');

const loadData = async (params = {}) => {
    const payload = {
        page: reportTransactions.state.currentPage || 1,
        report:report.value,
        search: search.value,
        column: sort.value.column,
        order: sort.value.order,
        ...params
    };
    const result = await reportTransactions.getReportTransactions(payload);
    if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' });
}

const loadMore = async () => {
    if (currentPage.value >= lastPage.value) return
    const newPage = reportTransactions.state.currentPage + 1;
    await loadData({ page: newPage });
}

const onSearch = async () => {
    await loadData({ page: 1, search: search.value });
}

const onSortChanged = async (sortData) => {
    sort.value.column = sortData.key;
    sort.value.order = sortData.order;
    await loadData({ column: sort.value.column, order: sort.value.order , page:1});
}

// Link Expenses 
const expenseLinkSidebar = ref(false);
const transaction = ref({});

const onlinkExpenses = (row) => {
    expenseLinkSidebar.value = true;
    transaction.value = {...row };
}


const submit = async(payload) => {
    const result = await reportTransactions.linkExpenses(payload);
    if (!result.success) {
        notify({ title: 'attention', text: 'message_error', color: 'warning' })
        return
    }
    const idx = reportTransactions.state.items.findIndex(el => el.id === payload.transactionId)
    if (idx !== -1) {
        reportTransactions.state.items[idx].status = result.response.item
    }
    expenseLinkSidebar.value = false
    notify({ title: 'success', text: 'message_update', color: 'success' })
}


//

onMounted(() => loadData());

</script>
